function isFurnishingObject(obj) {
    return Boolean(obj && obj.type === 'rectangle' && typeof obj.text === 'undefined' && !obj._isGridBadge);
}

function isLayoutObject(obj) {
    if (!obj || obj._isGridBadge) return false;
    return obj.type === 'rectangle' || obj.type === 'circle' || obj.type === 'group';
}

function isEditableInputElement(el) {
    return Boolean(el && (el.matches('input, textarea, select') || el.hasAttribute('data-active')));
}

function getGridContentBounds(headerCellSize, boxSize, gridWidth, gridHeight) {
    return {
        right: headerCellSize + gridWidth * boxSize,
        bottom: headerCellSize + gridHeight * boxSize
    };
}

function snapshotFurnitureState(obj) {
    return {
        left: obj.left,
        top: obj.top,
        width: obj.width,
        height: obj.height,
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        fill: obj.fill
    };
}

function restoreFurnitureState(obj, snapshot) {
    obj.set(snapshot);
}

function getAbsoluteObjectPosition(obj, canvas) {
    var cv = canvas || window.canvas;
    var group = cv && (cv._activeGroup || (typeof cv.getActiveGroup === 'function' && cv.getActiveGroup()));
    if (group && typeof group.contains === 'function' && group.contains(obj)) {
        var pt = fabric.util.transformPoint({ x: obj.left, y: obj.top }, group.calcTransformMatrix());
        return { left: pt.x, top: pt.y };
    }
    return { left: obj.left, top: obj.top };
}

function findFurnishingById(id, canvas) {
    var cv = canvas || window.canvas;
    if (!cv) return null;
    return cv.getObjects('rectangle').find(function (obj) {
        return obj.id === id && typeof obj.text === 'undefined';
    }) || null;
}

function getLabelsForFurniture(furnishingId, canvas) {
    var cv = canvas || window.canvas;
    if (!cv) return [];
    return cv.getObjects('text').filter(function (obj) {
        return obj._parentFurnitureId === furnishingId;
    });
}

function rgbToHex(colorValue) {
    if (!colorValue) return '#111111';
    if (colorValue[0] === '#') return colorValue;
    var channels = colorValue.match(/\d+/g);
    if (!channels) return '#111111';
    return '#' + channels.slice(0, 3).map(function (ch) {
        return Number(ch).toString(16).padStart(2, '0');
    }).join('');
}

module.exports = {
    isFurnishingObject: isFurnishingObject,
    isLayoutObject: isLayoutObject,
    isEditableInputElement: isEditableInputElement,
    getGridContentBounds: getGridContentBounds,
    snapshotFurnitureState: snapshotFurnitureState,
    restoreFurnitureState: restoreFurnitureState,
    getAbsoluteObjectPosition: getAbsoluteObjectPosition,
    findFurnishingById: findFurnishingById,
    getLabelsForFurniture: getLabelsForFurniture,
    rgbToHex: rgbToHex
};
